import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalLayout from './modalLayout';
import { SessionForm } from '../../';
import { useDispatch, useSelector } from 'react-redux';
import { updateSession, setEditSession, openModal, Modals } from '../../../redux/reducers';

const EditSessionModal = ({ open, editSession, onClose, ...rest }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { savingSession, sessionSaveError } = useSelector((state) => state.session);
  const { modalName } = useSelector((state) => state.ui);
  const [updatedSession, setUpdatedSession] = useState({ valid: false });

  const doUpdateSession = (data) => {
    dispatch(updateSession(data)).then((result) => {
      if (result != null) {
        // clear after creation
        dispatch(setEditSession(null));
        onClose();
      }
    });
  };

  useEffect(() => {
    if (sessionSaveError != null && modalName === Modals.EDIT_SESSION) {
      dispatch(
        // Closing error modal should open edit modal again so that user can try saving again without having to edit sessions data again
        openModal(
          {
            headerText: t('modal.error'),
            bodyText: `${t('interpreter.form.updateError')}: ${sessionSaveError?.message}`,
            onRightButtonClick: () => dispatch(openModal({}, Modals.EDIT_SESSION)),
            onClose: () => dispatch(openModal({}, Modals.EDIT_SESSION)),
          },
          Modals.ERROR
        )
      );
    }
  }, [sessionSaveError]);

  return (
    <ModalLayout
      open={open}
      headerText={t('modal.modifySession')}
      {...rest}
      leftButtonProps={{ bg: null }}
      rightButtonProps={{ color: 'white' }}
      leftButtonText={t('modal.cancel')}
      rightButtonText={t('modal.save')}
      disableRightButton={updatedSession.valid === false || savingSession === true}
      disableLeftButton={savingSession === true}
      onRightButtonClick={() => doUpdateSession(updatedSession.data)}
      showProgress={savingSession}
      onClose={onClose}
      size="lg"
    >
      <SessionForm
        editSession={editSession}
        onChanged={(createdSession) => setUpdatedSession(createdSession)}
      />
    </ModalLayout>
  );
};

EditSessionModal.propTypes = {
  open: PropTypes.bool,
  editSession: PropTypes.object,
  onClose: PropTypes.func,
};

EditSessionModal.defaultProps = {
  open: false,
};

export default EditSessionModal;
